import { Box, Typography } from "@mui/material";
import { Track } from "../../types";
import { MapPin } from "lucide-react";
import EditProperty from "../track-actions/edit-property";
import PropertyInfo from "../property";

export default function PropertyDetails({ track }: { track: Track }) {
  const { property } = track;
  const { compound } = property;

  return (
    <Box
      sx={{
        borderRadius: "12px",
        backgroundColor: "#FFFFFF",
        width: "100%",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      {/* Details Section */}
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={(theme) =>
              theme.nawy.typography.english.variants.body.md.semibold
            }
          >
            Property Details
          </Typography>
          <EditProperty property={property} trackTypeName={track.trackType.name} />
        </Box>
        <Box
          sx={(theme) => ({
            ...theme.nawy.typography.english.variants.body.sm.regular,
            color: theme.nawy.colors.semantic.text.secondary,
            gap: theme.nawy.spacing.xxs,
            display: "flex",
            alignItems: "center",
          })}
        >
          <MapPin size="14px" />
          {`${compound?.area?.name ?? "No area"} • ${
            compound?.developer?.name ?? "No developer"
          } • ${compound?.name}`}
        </Box>
      </Box>
      <Box>
        <Typography
          sx={(theme) => ({
            ...theme.nawy.typography.english.variants.body.sm.regular,
            color: theme.nawy.colors.semantic.text.secondary,
          })}
        >
          {property.description || "No description available."}
        </Typography>
      </Box>
      <PropertyInfo property={property} trackTypeName={track.trackType.name} />
    </Box>
  );
}
